import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchInput from './search-input';

export class SearchInputOverlay extends React.Component {
    constructor(props) {
        super(props);
    }

    searchInputContainerClick(event) {
        event.stopPropagation();
    }

    render() {
        const {displaySearchInputOverlay} = this.props;
        const searchInputOverlayClasses = classNames('search-input-overlay', {
            'search-input-overlay-show': displaySearchInputOverlay,
            'search-input-overlay-hide': !displaySearchInputOverlay
        });
        const searchInputProps = {
            searchIconClassNames: 'search-input-overlay-search-icon-mobile',
            textInputClassNames: 'search-input-overlay-text-input',
            searchInputClassNames: 'search-input-overlay-search-input',
            searchEventHandlers: [this.props.hideSearchInputOverlay],
            focusOnTextInput: displaySearchInputOverlay,
            textInputValue: ''
        };
        return (
            <div className={searchInputOverlayClasses} onClick={this.props.hideSearchInputOverlay}>
                <div className="search-input-overlay-container" onClick={this.searchInputContainerClick}>
                    <SearchInput {...searchInputProps} />
                </div>
            </div>
        );
    }
}

SearchInputOverlay.propTypes = {
    displaySearchInputOverlay: PropTypes.bool,
    hideSearchInputOverlay: PropTypes.func.isRequired
};




// WEBPACK FOOTER //
// ./src/components/search/search-input-overlay.js